import Player from "@vimeo/player";
import 'magnific-popup'
import $ from 'jquery'
import { TilingSprite } from "pixi.js";

class ModalPlayer {
  constructor(videoUrl, triggerSelector) {
    this.videoUrl = videoUrl;
    this.triggerSelector = triggerSelector;
    this.modalEl = null;
    this.player = null;
    this.iframe = null
    this.createModalTemplate();
  }

  createModalTemplate() {
    const modalId = `video-modal-${Math.random().toString(36).substring(2, 9)}`;
    const parsedVideoUrl = this.videoUrl.split('&')[0] + "?autoplay=1&muted=0&loop=0&controls=1&byline=0&title=0&playsinline=1&dnt=1";

    const modalWrapper = document.createElement('div');
    modalWrapper.id = modalId;
    modalWrapper.classList.add('video-modal', 'hidden');
    modalWrapper.innerHTML = `<div class="modal-wrapper">
        <div class="video-wrapper">
          <button title="Close (Esc)" type="button" class="video-modal-close">×</button>
            <iframe id="${modalId}-iframe" title="Video player" src="${parsedVideoUrl}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"></iframe>
          </div>
        </div>
      </div>
    `;

    this.modalEl = modalWrapper;
    $('body').append(modalWrapper);
    this.iframe = document.getElementById(`${modalId}-iframe`);
    this.player = new Player(this.iframe);

    this.setupEventListeners();
  }

  setupEventListeners() {
    $(this.triggerSelector).on('click', (e) => {
      e.preventDefault();
      this.openModal();
    });

    $(this.modalEl).find('.video-modal-close').on('click', () => {
      this.closeModal();
    });

    window.addEventListener('resize', ()=> this.checkAspectRatio())
  }

  playVideo() {
    this.player.getPaused().then(paused => {
      if (paused) {
        this.player.setVolume(1);
        this.player.play();
      }
    });
  }

  pauseVideo() {
    this.player.getPaused().then(paused => {
      if (!paused) {
        this.player.pause();
      }
    });
  }

  checkAspectRatio() {
    if (!this.iframe) return
    const iframeClientRect = this.iframe.getBoundingClientRect()

    if (iframeClientRect.width >= window.innerWidth && iframeClientRect.height >= window.innerHeight) {
      this.modalEl.classList.add('space-required')
    } else {
      this.modalEl.classList.remove('space-required')
    }

  }

  openModal() {
    $('html').css('overflow', 'hidden');
    this.modalEl.classList.remove('hidden');
    this.checkAspectRatio();
    this.playVideo();
  }

  closeModal() {
    $('html').css('overflow', '');
    this.modalEl.classList.add('hidden');
    this.pauseVideo();
  }
}

export default ModalPlayer;
